// FormItemComponent.js
import React from "react";
import { Form, Input, Checkbox, Select, Button, Space, DatePicker } from "antd";
import dayjs from "dayjs";
import utils from "utils";
import { DeleteOutlined } from "@ant-design/icons";
import FormItemsComponent from "./FormItemsComponent";
const { Option } = Select;
import FormFieldValidator from "./FormFieldValidator";
import FormFieldNormalize from "./FormFieldNormalize";
import { AddBefore, AddOn } from "./AddOn";
import Validators from "Common/Validators";
const FormItemComponent = ({
  keyProp,
  name,
  value,
  fieldOptions,
  fieldValue,
  form,
  formClass,
}) => {
  const label = utils.capitalizeAndReplace(keyProp);
  const formValidator = FormFieldValidator?.[formClass]?.[keyProp] || [];
  const formNormalize = FormFieldNormalize?.[formClass]?.[keyProp] || null;
  const fieldType = fieldValue?.[keyProp] || null;
  const InputProps = {
    key: name,
    label: label,
    name: name,
    rules: formValidator,
    normalize: formNormalize,
  };
  const InputItemProps = {
    addonBefore: AddBefore?.[keyProp] || "",
    addonAfter: AddOn?.[keyProp] || "",
  };
  if (fieldType == "year") {
    return (
      <Form.Item {...InputProps} rules={Validators.validateYear}>
        <Input placeholder="YYYY" />
      </Form.Item>
    );
  } else if (fieldType === "textarea") {
    return (
      <Form.Item {...InputProps}>
        <Input.TextArea {...InputItemProps} />
      </Form.Item>
    );
  } else if (fieldType === "select" && !Array.isArray(value)) {
    const options = fieldOptions[keyProp] || [];
    return (
      <Form.Item {...InputProps}>
        <Select placeholder={`Select ${keyProp}`}>
          {options.map((option, index) => (
            <Option key={index} value={option}>
              {option}
            </Option>
          ))}
        </Select>
      </Form.Item>
    );
  } else if (fieldType === "numbers" && typeof value ==="string") {
    if(InputProps.rules.length==0){
      InputProps.rules=[Validators.checkOnlyNumber]
    }
    return (
      <Form.Item {...InputProps}>
        <Input  {...InputItemProps} />
      </Form.Item>
    );
  } else if (typeof value === "number") {
    return (
      <Form.Item {...InputProps}>
        <Input type="number" {...InputItemProps} />
      </Form.Item>
    );
  } else if (typeof value === "boolean") {
    return (
      <Form.Item {...InputProps} valuePropName="checked">
        <Checkbox />
      </Form.Item>
    );
  } else if (typeof value === "string") {
    // Check if the field type is defined in fieldValue
    return (
      <Form.Item {...InputProps}>
        <Input {...InputItemProps} />
      </Form.Item>
    );
  } else if (Array.isArray(value)) {
    if (
      typeof value[0] === "string" ||
      typeof value[0] === "number" ||
      value.length == 0
    ) {
      const options = fieldOptions[keyProp] || [];
      return (
        <Form.Item {...InputProps}>
          <Select mode="multiple" placeholder={`Select ${keyProp}`}>
            {options.map((option, index) => (
              <Option key={index} value={option}>
                {option}
              </Option>
            ))}
          </Select>
        </Form.Item>
      );
    } else if (typeof value[0] === "object") {
      return (
        <Form.List key={name} name={name}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key: fieldKey, name: fieldName }) => (
                <div
                  key={fieldKey}
                  style={{
                    display: "flex",
                    marginBottom: 8,
                    alignItems: "flex-start",
                    gap:"4px",
                  }}                  
                >
                  {Object.keys(value[0]).map((nestedKey) => {
                    const nestedValue = value[0][nestedKey];
                    const nestedName = [fieldName, nestedKey];
                    return (
                      <FormItemComponent
                        keyProp={nestedKey}
                        name={nestedName}
                        value={nestedValue}
                        fieldOptions={fieldOptions}
                        fieldValue={fieldValue}
                        form={form}
                        formClass={formClass}
                      />
                    );
                  })}
                  <Form.Item
                  // style={{
                  //   display: "flex",
                  //   flexDirection: "column",
                  //   justifyContent: "flex-end",
                  // }}
                  label={"Action"}
                  >
                    <Button type="dashed" onClick={() => remove(fieldName)}>
                      <DeleteOutlined />
                    </Button>
                  </Form.Item>
                </div>
              ))}
              <Button type="dashed" onClick={() => add()}>
                Add {utils.capitalizeAndReplace(keyProp)}
              </Button>
            </>
          )}
        </Form.List>
      );
    }
  } else if (typeof value === "object" && value !== null) {
    const isKey = `is_${keyProp}`;
    let tempobj;
    if (value[isKey] !== undefined) {
      tempobj = Object.fromEntries(
        Object.entries(value).filter(([childkey]) => childkey !== isKey)
      );
    }
    return (
      <div key={name}>
        <h4>{utils.capitalizeAndReplace(keyProp)}</h4>
        {value[isKey] !== undefined ? (
          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => {
              const show = getFieldValue([...name, `is_${keyProp}`]);
              return (
                <>
                  <FormItemComponent
                    keyProp={isKey}
                    name={[...name, isKey]}
                    value={value[isKey]}
                    fieldOptions={fieldOptions}
                    fieldValue={fieldValue}
                    form={form}
                    formClass={formClass}
                  />
                  {show && (
                    <FormItemsComponent
                      obj={tempobj}
                      parentName={name}
                      fieldOptions={fieldOptions}
                      fieldValue={fieldValue}
                      form={form}
                      formClass={formClass}
                    />
                  )}
                </>
              );
            }}
          </Form.Item>
        ) : (
          <FormItemsComponent
            obj={value}
            parentName={name}
            fieldOptions={fieldOptions}
            fieldValue={fieldValue}
            form={form}
            formClass={formClass}
          />
        )}
      </div>
    );
  }
  return null;
};

export default FormItemComponent;
